<template>
  <v-form action="javascript:void(0);"  class="single-string-input-dialog pa-3">
    <template v-if="aboveText">
      {{$tf(aboveText)}}
      <br />
    </template>
    <v-text-field
        v-model="field.value"
        :rules="field.rules"
        :label="$tf(label)"
        :counter="computedCounter"
        :hint="hint"
        :persistent-hint="persistentHint"
        @input="$store.dispatch('dialog/setData', $event)"
        autofocus />
  </v-form>
</template>

<script>
  import useInPlaceValidation from '~/commons/validation'
  import { ref } from '@vue/composition-api'

  export default {
    name: 'dialog-single-string-input',
    props: {
      label: {
        type: String,
        default: ''
      },
      maxLength: {
        type: Number,
        default: 100
      },
      minLength: {
        type: Number,
        default: 1
      },
      value: {
        type: String,
        default: ''
      },
      counter: {
        type: Boolean,
        default: true
      },
      hint: {
        type: String,
        default: ''
      },
      persistentHint: {
        type: Boolean,
        default: false
      },
      aboveText: String
    },
    setup (props) {
      const { fields, setValidationCallback } = useInPlaceValidation({
        field: {
          name: props.label,
          rules: ['required', 'minLength:' + props.minLength, 'maxLength:' + props.maxLength],
          value: ref(props.value)
        }
      })
      return {
        field: fields.field,
        setValidationCallback
      }
    },
    mounted () {
      this.setValidationCallback(this.setValid)
    },
    methods: {
      setValid (valid) {
        this.$store.dispatch('dialog/setValid', valid)
      }
    },
    computed: {
      computedCounter () {
        if (!this.counter || this.maxLength < 1) {
          return false
        }
        return this.maxLength
      }
    }
  }
</script>

<style lang="scss">

  .dialog-drop-file .drop-box {
    transition: none !important;
    padding: 3rem 0 3rem 0 !important;

    &.has-files {
      padding: 3rem 0 1rem 0 !important;
    }
  }

</style>

<style lang="scss" scoped>
  @media screen and (max-width: 599px) {
    .input-group {
      margin-top: 25px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/dialog/types/DialogSingleStringInput.vue